import { API, unwrapData } from '../axios-instance'

export type License = {
  id: string
  name: string
  recognition: boolean
  nominations: boolean
  checkIns: boolean
  incentives: boolean
  enhancedKtv: boolean
  refinement: boolean
  resourceHub: boolean
  customRewards: boolean
  createdAt: string
  __entity_type__: 'license'
}

export enum FeatureEnum {
  NOMINATIONS = 'nominations',
  CHECK_INS = 'checkIns',
  INCENTIVES = 'incentives',
  ENHANCED_KTV = 'enhancedKtv',
  RECOGNITION = 'recognition',
  REFINEMENT = 'refinement',
  RESOURCE_HUB = 'resourceHub',
  CUSTOM_REWARDS = 'customRewards',
}

export type LicenseFeatures = Record<FeatureEnum, boolean>

export const getLicenseFeatures = async () => {
  return await API.get<LicenseFeatures>('/identity/license/features').then(unwrapData)
}
